module.exports = __webpack_public_path__ + "static/media/assign.a11d79f9.svg";